export default __webpack_public_path__ + "static/media/applications-image-23.ed4f5774.jpg";